import { useEffect, useState } from 'react'

export function useCountUp(target: number, durationMs: number) {
	const [value, setValue] = useState(0)
	useEffect(() => {
		let raf: number
		const start = performance.now()
		const tick = (now: number) => {
			const t = Math.min((now - start) / durationMs, 1)
			const eased = 1 - Math.pow(1 - t, 3)
			setValue(target * eased)
			if (t < 1) raf = requestAnimationFrame(tick)
		}
		raf = requestAnimationFrame(tick)
		return () => cancelAnimationFrame(raf)
	}, [target, durationMs])
	return value
}
